import React from "react";
import { Link } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import Logo from "@logos/RDEC-WHITE-NOBG.png";

const FooterLogo = ({ logo }: { logo: string | null }) => (
  <div className="select-none space-y-4">
    <Link to="/" aria-label="Home" className={`m-5`}>
      <img src={logo || Logo} alt="Footer Logo" className="h-auto w-64" />
    </Link>
    <ContactInfo />
    <p className="text-sm text-gray-400">
      Referência no fornecimento de soluções em automação industrial para o
      setor de Óleo & Gás. Equipamentos de última geração, eficiência, segurança
      e inovação.
    </p>
  </div>
);

const ContactInfo = () => (
  <ul className="select-text space-y-2 text-sm">
    {/*<li className="flex items-center space-x-2">*/}
    {/*  <FontAwesomeIcon icon={faPhone} />*/}
    {/*  <a*/}
    {/*    href="tel:+5528992432421"*/}
    {/*    className="hover:text-gray-100"*/}
    {/*    aria-label="Call us"*/}
    {/*  >*/}
    {/*    +55 28 99243-2421*/}
    {/*  </a>*/}
    {/*</li>*/}
    <li className="flex items-center space-x-2">
      <FontAwesomeIcon icon={faEnvelope} />
      <a
        href="mailto:contato@rdec.com.br"
        className="hover:text-gray-100"
        aria-label="Email us"
      >
        contato@rdec.com.br
      </a>
    </li>
  </ul>
);

const FooterLinks = ({
  title,
  links,
}: {
  title: string;
  links: { to: string; label: string }[];
}) => (
  <div className="flex flex-col items-center justify-start space-y-4 p-4">
    <h3 className="text-3xl font-semibold text-gray-100">{title}</h3>
    <ul className="space-y-2 text-sm">
      {links.map((link, idx) => (
        <li key={idx}>
          <Link
            to={link.to}
            onClick={() => window.scrollTo(0, 0)}
            className="hover:text-gray-100"
          >
            {link.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

const SocialLinks = () => (
  <div className="mt-4 flex items-center space-x-4 md:mt-0">
    <span className="text-gray-400">Follow us:</span>
    <Link to="#" aria-label="Facebook" className="hover:text-gray-100">
      <FontAwesomeIcon icon={faFacebook} />
    </Link>
    <Link to="#" aria-label="Instagram" className="hover:text-gray-100">
      <FontAwesomeIcon icon={faInstagram} />
    </Link>
    <Link to="#" aria-label="LinkedIn" className="hover:text-gray-100">
      <FontAwesomeIcon icon={faLinkedin} />
    </Link>
  </div>
);

const FooterView = (props: { footerLogo: string | null }) => {
  const { footerLogo } = props;

  return (
    <footer className="w-full select-none bg-gray-900 p-4 text-gray-300">
      <div className="mx-auto grid max-w-7xl gap-8 px-6 py-12 md:grid-cols-3">
        <FooterLogo logo={footerLogo} />
        <FooterLinks
          title="Sobre Nós"
          links={[
            { to: "/about-us", label: "Quem somos" },
            { to: "/compliance", label: "Ética e Compliance" },
            { to: "/contact-us", label: "Nosso Contato" },
          ]}
        />
        <FooterLinks
          title="Links Úteis"
          links={[
            { to: "/portfolio", label: "Nossos Produtos" },
            { to: "/contact-us", label: "Entre em contato" },
          ]}
        />
      </div>

      <hr className="my-6 border-gray-700" />

      {/* Footer Bottom */}
      <div className="flex flex-col items-center justify-between px-6 text-sm text-gray-500 md:flex-row">
        <div>
          © 2025{" "}
          <Link to="/" className="hover:text-gray-100">
            Restart Design & Consulting
          </Link>
          . All Rights Reserved.
        </div>
        {/*<SocialLinks />*/}
      </div>
    </footer>
  );
};

export default FooterView;
